import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
const Intro = () => {
  return (
    <div className="mobile01">
      <div className="   row ">
        <div  >
          <div className=" justify-content-between mobile02">
            <div
              className=" col-lg-8 newcard  "
              style={{
                padding: "2rem",
                marginTop: "1.5rem",
                marginBottom: "3.5rem",
                marginLeft: "1rem",
                borderRadius: "1.5rem",backgroundColor:'white'
              }}>
              <div className="intro-excerpt">
                <h1>Welcome To Roha Powers</h1>
                <p
                  className="mb-4"
                  style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                Roha Powers is a global brand of Roha logistics PLC and one of the largest power bank sharing service of shared mobile treasure in Ethiopia.
                </p>
                <p>
                  <Link to="/">
                    <a
                      href=""
                      className="btn btn-primary me-2"
                      style={{ color: "white" }}>
                      Shop Now
                    </a>
                  </Link>
                  <Link to="/">
                    <a href="#" className="btn btn-white-outline">
                      Explore
                    </a>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
